export default function mapGroupBy<K, T>(input: T[], predicate: (value: T) => K): Map<K, T[]> {
  return input.reduce(
    (entryMap, e) => {
      return entryMap.set(predicate(e), [...entryMap.get(predicate(e)) || [], e]);
    },
    new Map()
  );
}
